import { admCost } from './adm';
import { flightCost } from './rich';
import { flightCost8 } from './burden8';
import {onBudgetPassed,startProvisional,startSperre} from './fiscal';
import type {Positions} from './types';
import {BWANT,GEIN} from '../content/economy';
import {RESS,RID} from '../content/ressorts';
import {MONTHS,NEED} from '../content/consts';
import {OUTLETS,PARTIES} from '../content/parties';
import {DI,DM,on} from '../content/settings';
import {inflRev,interestV7} from './economy';
import {toast} from './govern';
import {budgetReactLW} from './lobbies';
import {leader,press} from './media';

import {rnd} from './rng';
import {PA,PN,score} from './rules';
import {S,log} from './state';
import {clamp,dateLabel,dateYear} from './util';


export const amp=(x:any)=>x<0?x*1.3:x;
export const etatSum=(E?:any)=>RESS.reduce((s:any,r:any)=>s+(((E||S.etat)||{})[r.id]||0),0);
export const interest:any=()=>interestV7();
export function structSaldo(){return -admCost()-flightCost()-flightCost8()-18+S.lawB+(S.gr-.6)*6+S.shockB-interest()-etatSum()+(S.ein||0)+inflRev()-(on('demo')?S.demoCost:0)}
export const debtLimit:any=()=>-25-Math.max(0,1-S.gr)*10-(S.limBonus||0);
export const notlageOk=():boolean=>S.gr<0||(S.crisisM!=null&&S.m-S.crisisM<=9);
export function etatIss(id?:any,E?:any){E=E||S.etat||{};let s=0;RESS.forEach((r:any)=>{if(r.iss.includes(id))s+=(E[r.id]||0)*.035/r.iss.length});return s}
export function etatGr(E?:any,ein?:any){E=E||S.etat||{};ein=ein??(S.ein||0);return RESS.reduce((s:any,r:any)=>s+(E[r.id]||0)*r.gr,0)-ein*.008}
export function etatMonthly(){
  RESS.forEach((r:any)=>{const x=(S.etat||{})[r.id]||0;if(x)for(const g in r.g)S.bonus[g]+=amp(x*r.g[g])*.03});
  const e=S.ein||0;if(e)for(const g in GEIN)S.bonus[g]+=amp(e*GEIN[g])*.03;
}
export function nextBudgetMonth(){let m=S.m+1;while((11+m)%12!==6)m++;return m}
export function openBudget(){
  S.budget={stage:'draft',left:0,year:dateYear(S.m)+1,etat:{...(S.etat||{})},ein:S.ein||0,not:false};
  log(`Haushaltsverhandlungen für ${S.budget.year} beginnen. Das Kabinett muss einen Entwurf beschließen.`);toast(`Haushaltsverhandlungen ${S.budget.year}`,'');
}
export function budgetProj(B?:any){return S.saldo-(etatSum(B.etat)-etatSum())+(B.ein-(S.ein||0))}
export function budgetPos(B?:any):Positions{const e=(k:any)=>B.etat[k]||0,pr=budgetProj(B);
  return{sozial:clamp((e('as')+e('ge')+e('bf')+e('bw'))/6+B.ein/10,-2,2),haushalt:clamp(-(pr+15)/8,-2,2),klima:clamp((e('uk')+e('vk')*.5)/3,-2,2),sicherheit:clamp((e('vt')+e('in'))/4,-2,2)}}

export function budgetReact(B?:any){
  const pos=budgetPos(B),pr=budgetProj(B),lim=debtLimit();
  return S.partners.map((p:any)=>{let s=score(p,pos),cut:any=null;
    RESS.forEach((r:any)=>{if(S.ress[r.id]===p){const x=B.etat[r.id]||0;s+=clamp(x*.012,-.08,.05);if(x<=-2&&(!cut||x<B.etat[cut]))cut=r.id}});
    if(S.ress.fin===p&&pr<lim&&!B.not)return{p,s,ok:false,why:'Der Finanzminister besteht auf der Schuldenbremse.'};
    let why='';if(cut)why=`Wehrt sich gegen Kürzungen im Ressort ${RID[cut].n}.`;
    else{let wa:string|null=null,wv=0;for(const a in pos){const g=PARTIES[p].w[a]*Math.abs(pos[a]-PARTIES[p].pos[a]);if(g>wv){wv=g;wa=a}}
      if(wa)why=`Will ${BWANT[wa][pos[wa]<PARTIES[p].pos[wa]?0:1]}.`}
    return{p,s,ok:s>=.55,why}})
}
export function budgetVote(B?:any){const pos=budgetPos(B);let yes=0;const by:any={};
  for(const id of S.res.inP){const c=id==='YOU'||S.partners.includes(id);const y=c?(id==='YOU'||S.coal>=20):score(id,pos)>=(S.minority?.68:.8);by[id]=y;if(y)yes+=S.res.seats[id]}
  return{yes,by}}
export function courtRisk(B?:any){if(B.not)return .1;const over=debtLimit()-budgetProj(B);return over<=2?0:clamp(.25+over*.05,0,.85)}
export function budgetCabinet(force?:any){
  const B=S.budget,R=budgetReact(B),bad=R.filter((x:any)=>!x.ok);
  if(bad.length&&!force)return;
  bad.forEach((x:any)=>{S.coal=clamp(S.coal-12,0,100);log(`${PN(x.p)} fügt sich nur unter Protest dem Haushaltsentwurf.`,'bad')});
  if(bad.length)press(OUTLETS[0].n,'Haushaltsstreit: Kanzleramt setzt Etat gegen den Koalitionspartner durch',-1);
  if(!B)return;
  if(B.not){press(OUTLETS[1].n,'Regierung erklärt Notlage und setzt die Schuldenbremse aus',-.8);log('Die Regierung erklärt eine Notlage. Die Schuldenbremse ist für dieses Jahr ausgesetzt.')}
  B.stage='bt';B.left=4;S.bview=false;
  log(`Kabinett beschließt den Haushaltsentwurf ${B.year}. Der Bundestag stimmt im ${dateLabel(S.m+4)} ab.`);
}
export function budgetTick(){
  let att=false;const rel=S.m-S.m0;
  if(!S.budget&&(11+S.m)%12===6&&rel<MONTHS-3){openBudget();att=true}
  const B=S.budget;
  if(B&&B.stage==='bt'&&--B.left<=0){
    const v=budgetVote(B),ok=v.yes>=NEED,pr=budgetProj(B);
    S.lastVote={id:'hh'+S.m,m:S.m,t:`Bundeshaushalt ${B.year}`,yes:v.yes,ok,by:v.by};
    if(ok){
      if(B.ein>(S.ein||0))S.promises.filter((p:any)=>p.k==='tax'&&p.leg===S.leg&&p.state==='open').forEach((p:any)=>{p.state='broken';S.basis-=1;press(OUTLETS[1].n,'Wortbruch: Regierung erhöht Steuern trotz Wahlversprechen',-1.5);log('Mit den Steuererhöhungen brecht ihr euer Wahlversprechen.','bad')});
      onBudgetPassed();budgetReactLW(B);S.etat={...B.etat};S.ein=B.ein;S.notYear=B.not?B.year:null;S.saldo=structSaldo();
      log(`Bundestag beschließt den Haushalt ${B.year} mit ${v.yes} Stimmen.`,'good');press(OUTLETS[0].n,`Bundestag verabschiedet Haushalt ${B.year}`,.4);toast(`Haushalt ${B.year} beschlossen (${v.yes} Ja)`,'good');
      S.budgets.push({y:B.year,saldo:pr,ok:true,not:B.not});
      const over=debtLimit()-pr;
      if(on('court')&&((!B.not&&over>2&&rnd()<.75*DM())||(B.not&&rnd()<.4*DM()))){const kl=leader()||'BU';S.court={m:S.m+5,over,not:B.not,year:B.year,by:kl};
        log(`${PN(kl)} klagt in Karlsruhe gegen den Haushalt ${B.year}. Das Urteil wird im ${dateLabel(S.m+5)} erwartet.`,'bad');press(OUTLETS[1].n,`${PA(kl)} zieht gegen den Haushalt vor das Verfassungsgericht`,-.6)}
    }else{
      S.basis-=.8;log(`Der Haushalt ${B.year} scheitert im Bundestag (${v.yes} Ja). Es gilt die vorläufige Haushaltsführung.`,'bad');press(OUTLETS[0].n,`Haushalt durchgefallen: Regierung ohne Etat für ${B.year}`,-1.5);toast(`Haushalt ${B.year} gescheitert`,'bad');
      S.budgets.push({y:B.year,saldo:pr,ok:false,not:B.not});startProvisional(B.year);
    }
    S.budget=null;att=true;
  }
  if(S.court&&S.m>=S.court.m){const c=S.court;S.court=null;
    const p=(c.not?(S.gr<0?.1:.35):clamp(.3+c.over*.05,0,.85))*[.6,1,1.2][DI()];
    if(rnd()<p){startSperre(c.year);
    }else{S.basis+=.3;press(OUTLETS[0].n,`Verfassungsgericht weist Klage gegen den Haushalt ${c.year} ab`,.8);log(`Karlsruhe bestätigt den Haushalt ${c.year}.`,'good');toast('Karlsruhe bestätigt den Haushalt','good')}
    att=true}
  return att;
}
export function blocker(){
  if(S.budget&&S.budget.stage==='draft')return 'Erst muss das Kabinett den Haushaltsentwurf beschließen.';
  if(S.scandal)return `Entscheidet erst, ob ${S.min[S.scandal.rid].n} im Amt bleibt.`;
  if(S.pickFor)return 'Ernennt erst die neue Besetzung des Ressorts.';
  if(S.crisis)return 'Entscheidet erst, wie ihr auf die Krise reagiert.';
  if(S.dec)return 'Erst steht eine Entscheidung an.';
  if((S as any).qr)return 'Lest erst die Bilanz.'; // Version 12
  if((S as any).dem?.card)return 'Entscheidet erst, wie ihr auf den Widerstand reagiert.'; // Version 11
  if(S.laws.some((L:any)=>L.stage==='coord'&&L.coord&&L.coord.wait==='YOU'))return 'Ein Entwurf in der Ressortabstimmung wartet auf eure Antwort.';
  if(S.ptag)return 'Erst muss der Parteitag über den Antrag entscheiden.';
  if(S.oppMove)return 'Erst müsst ihr auf die Opposition reagieren.';
  if(S.donOffer)return 'Erst entscheidet ihr über die Spende.';
  if(S.pre&&S.pre.leg===S.leg&&S.pre.duels.some((d:any)=>!d.done&&S.m>=d.at&&d.q.length))return 'Erst steht das TV-Duell an.';
  return null;
}
